import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 40px;
`;

export const ContainerPreview = styled.div`
  position: absolute;
  display: block;
  margin-top: 40px;
  width: 903px;
  height: 547px;
  overflow: auto;

  @media (max-width: 1500px) {
    width: 645px;
    height: 389px;
    margin-top: 30px;

    > div {
      zoom: 0.7;
      -moz-transform: scale(0.7);
    }
  }

  @media (max-width: 1200px) {
    width: 552px;
    height: 334px;
    margin-top: 25px;
  }
`;

export const MockupDesktop = styled.img`
  z-index: 2;
  max-width: 980px;
  width: 100%;

  @media (max-width: 1500px) {
    max-width: 700px;
  }

  @media (max-width: 1200px) {
    max-width: 600px;
  }
`;
